// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const environmentCommonValues = {
  status: {
    draft: "草稿",
    active: "启用",
    published: "已发布",
    archived: "归档",
    disabled: "停用",
  },
  visibility: {
    private: "私有",
    shared: "共享",
  },
  values: {
    undefinedBoolean: "未定义布尔值",
  },
  usageTypes: {
    target_device: "被测设备",
    template_source: "模板来源",
  },
  architectures: {
    x86_64: "x86_64",
    arm64: "ARM64",
    i386: "i386",
    other: "其他",
  },
} as const;
